import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from '../locales/en.json';
import fr from '../locales/fr.json';
import es from '../locales/es.json';
import ar from '../locales/ar.json';
import pt from '../locales/pt.json';
import sw from '../locales/sw.json';
import ha from '../locales/ha.json';
import yo from '../locales/yo.json';
import tw from '../locales/tw.json';
import ig from '../locales/ig.json';
import zu from '../locales/zu.json';
import am from '../locales/am.json';

const savedLang = (() => {
    try {
        const saved = localStorage.getItem('gigship_language');
        return saved ? saved.toLowerCase() : 'en';
    } catch { return 'en'; }
})();

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            fr: { translation: fr },
            es: { translation: es },
            ar: { translation: ar },
            pt: { translation: pt },
            sw: { translation: sw },
            ha: { translation: ha },
            yo: { translation: yo },
            tw: { translation: tw },
            ig: { translation: ig },
            zu: { translation: zu },
            am: { translation: am }
        },
        lng: savedLang,
        fallbackLng: 'en',
        interpolation: { escapeValue: false },
        react: { useSuspense: false }
    });

// Normalize any previously saved uppercase lang code
try {
    const saved = localStorage.getItem('gigship_language');
    if (saved && saved !== saved.toLowerCase()) {
        localStorage.setItem('gigship_language', saved.toLowerCase());
    }
} catch { }

// Diagnostic logs — confirms init ran and resources loaded
console.log('[i18n] Ready. Language:', i18n.language);
console.log('[i18n] Available languages:', Object.keys(i18n.options.resources || {}));
console.log('[i18n] FR test:', i18n.t('pages.gigs_listing.title', { lng: 'fr' }));

// Handle RTL and lang attribute on every language change
i18n.on('languageChanged', (lng) => {
    const langCode = lng.split('-')[0];
    document.documentElement.dir = langCode === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = langCode;
    localStorage.setItem('gigship_language', langCode);
    console.log('[i18n] Language changed to:', langCode);
});

// Set initial layout
document.documentElement.dir = savedLang === 'ar' ? 'rtl' : 'ltr';
document.documentElement.lang = savedLang;

export default i18n;
